(function ($) {
    $(document).ready( function() {
        
      //init_slider_wds();

      $("input[name='updates[]']").on('input', function() {
        $( "input[name='update']" ).trigger( "click" );
      });


      if ($(".hero-custom").length == 0 ){
        $(".site-header, .site-header__mobile-nav").addClass("dark");
      }

      if ( $("#shopify-section-section-guide-banner").length > 0 ||
          $(".template-cart").length > 0 ){
        $(".site-header, .site-header__mobile-nav").removeClass("dark");
      }

      
      setTimeout(() => {

        if ( $("#shopify-section-161597494002d42fd6").length > 0 ) {

          let section_scroll_to = $("#shopify-section-161597494002d42fd6");
          let e_offset = section_scroll_to.offset();
          console.log(e_offset);
          let e_to = e_offset.top;
  
          $("a[href='#scrollto']").on( "click", function(){
          
            window.scrollTo({
              top: e_offset.top,
              behavior: "smooth"
            });
          });
        
        }
        
      }, 500);

     
    
      // Change radio buttons style

      $(".product-form__item .radio-input").each( function(){
        if($(this).find("input").attr("checked")) {
          $(this).addClass("checked");
        }
      });

      $(".product-form__item .radio-input").on('click', function(){
        setTimeout(function(){
          let price = $('.price__sale .price-item--sale').html();
        $('.btn_price').html(price)
        },100)
      });

      $(".product-form__item .radio-input input").on( "click", function(){
        $(this).parent().siblings().removeClass("checked");
        $(this).parent().addClass("checked");
        
        

        let parent = $(this).closest(".product-single__meta");
  		let parent_thumb = $(".product-slider-wrapper");

        if($(this).val() == 'with Stand') {
          parent.find(".product-single__description").addClass("active");
          parent_thumb.find(".slick-dots li:nth-child(2)").click();
        } else if ($(this).val() == 'with Clips') {
          parent.find(".product-single__description").addClass("active");
          parent_thumb.find(".slick-dots li:nth-child(3)").click();
        } else {
          parent.find(".product-single__description").removeClass("active");
          parent_thumb.find(".slick-dots li:nth-child(1)").click();
        }
      });

      // Change product quantitiy in custom featured product section
      $(document).on("click", ".product-quantity-set", function(e) {
      
        let current_val =  Number($(this).siblings("input").val());
        let new_val = 0;
        if ($(this).hasClass('plus')) {
            new_val = current_val+1;
          console.log(current_val);
          
        } else if ($(this).hasClass('minus')) {
          new_val = current_val-1;
        }

        if (new_val < 2 ) {
          new_val = 1;
        } else if (new_val > 5){
          new_val = 5;
        }
        
        if($('.product-form__cart-submit .btn_price').length) {
          var price = $('.price-item--sale').html().replace('$', '')
          price = parseFloat(price)
          price = price * new_val
          price = price.toFixed(2).toString()
          console.log($('.product-form__input--quantity').val())
          $('.product-form__cart-submit .btn_price').html('$'+price)
        }
        
        
        // 	BANDLE CODE SCRIPT
        if ($('.bandle_info').length > 0) {
          $('.bandle_info p').removeClass('active')
          $('.price__regular').removeClass('line_thrue')
          $('.price__sale').removeClass('show')
          if(new_val == 2){
            console.log('val 2')
            $('.bandle_info p:eq(0)').addClass('active')
          } else if (new_val >= 3){
            console.log('val 3')
            $('.bandle_info p:eq(1)').addClass('active')
          }
        }

        $(this).siblings("input").val(new_val);    
        var parent = $(e.target).closest('.cart__row');      
        var currentVariant = parent.attr('data-cart-item-key');
        if ( typeof currentVariant !== 'undefined') {

          $(this).siblings("input").trigger("change");

          $.ajax({
            url:'/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: { quantity: new_val, id: currentVariant },
            success: function(res) {
              
              console.log(res)
            
              res.items.forEach(item => {
                $(".cart-table tr").each(function(){
                  if($(this).attr("data-cart-item-key") ==  item.variant_id ) {
                    let price = theme.Currency.formatMoney(item.final_line_price, theme.moneyFormat),
                        original_price = theme.Currency.formatMoney(item.original_line_price, theme.moneyFormat);
                    console.log('work: '+original_price)
                   
                    if (price != original_price) {
                      $(this).find("[data-cart-item-original-price]").html(original_price);
                      $(this).find(".order-discount").html(price);
                    } else {
                      $(this).find(".line-final-price").html(price);
                    }
                    $(this).find(".line-final-price").html(price);
                  }
                });
              });

              let propose = get_propose(res);
       
              if (propose) {
                $(document).find(".cart-popup-extended .upgrade").removeClass("hide");
                
              } else {
                $(document).find(".cart-popup-extended .upgrade").addClass("hide");
              }

              let total_amount = theme.Currency.formatMoney(res.total_price, theme.moneyFormat);
              $(".cart-subtotal__price").text(total_amount);
            
              $("[data-cart-count]").text(res.item_count);
            }
          });
        }
      } );

      $(".product-form button").on("click", function(e){
        e.preventDefault();
        let form_data = $(this).closest("form").serialize();
      
        window.loader =  $(this).find("[data-loader]");
        window.button_text =  $(this).find("[data-add-to-cart-text]");
        button_text.addClass("hide");
        loader.removeClass("hide");
        add_to_cart(form_data);
      });
  
  	$(".updateItemToCart_x2").on("click", function(e){
        e.preventDefault();
        let formData = {
         'items': [{
          'id': 39808374833341,
          'quantity': 2
          }]
        };

        add_to_cart(formData);
      });

      $(".updateItemToCart_x3").on("click", function(e){
        e.preventDefault();
        let formData = {
         'items': [{
          'id': 39808374833341,
          'quantity': 3
          }]
        };

        add_to_cart(formData);
      });
  
  $('.single_bundle button').on('click', function(e){
    e.preventDefault();
    let id = $(this).attr('bandle-id'), qty =  $(this).attr('bandle-qty');
        let formData = {
         'items': [{
          'id': id,
          'quantity': qty
          }]
        };

        add_to_cart(formData);
  })
  
//   $('.bundles_blocks').slick({
//     dots: false,
//     infinite: false,
//     arrows: false,
//     slidesToShow: 4,
//     centerMode: false,
//     responsive: [
//       {
//         breakpoint: 1023,
//         settings: {
//     		centerMode: false,
//     	variableWidth: true,
//           dots: true,
//           slidesToShow: 1,
// 		  slidesToScroll: 2
//         }
//       }
//     ]
//   });
  
  $(".updateItemToCart").on("click", function(e){
        e.preventDefault();
    
        
    
        let id = $(this).closest(".cart__row").attr("data-id");
        let qty = $(this).closest(".cart__row").find(".cart__qty-input").val();
    	let count = 0;
        console.log('id = ', id);
        console.log('qty = ', qty);
    
    	if ($('.cart-table tbody .cart__row').length > 1) {
          $('.cart-table tbody .cart__row').each(function(){
            if($(this).find('.cart__qty-input').length > 0){
              count = parseInt($(this).find('.cart__qty-input').val());
            }
          })
        }
    
    	let formData = {
         'items': [{
          'id': id,
          'quantity': qty
          }]
        };
    
	    if (count > qty){
          let new_count = count - qty;
          data = {
            "updates": {
              "39808374833341": new_count
            }
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(response){
              add_to_cart(formData);
            }
          });
          
        } else {
          if ($('.cart-table tbody .cart__row').length > 1) {
	          $('.cart-table tbody .cart__row:last-child').remove()
          }
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            success: function() {
              add_to_cart(formData);
            },
            error: function(XMLHttpRequest, textStatus) {
              /* error code */
            }
          });
          
        }
    
        
		
      });

      $(".cart-popup-extended .cart__add").on("click", function(e){
        e.preventDefault();
        let item = $(this).closest("tr");
        let form_data  = 'pr_var='+item.attr("data-pr-var")+'&id='+item.attr("data-id")+'&quantity='+item.find('.cart__qty-input').val();
        
        get_cart_data_upsale(form_data);
      });
  
      $(document).ready(function() {

       $(".discount_buttons-slider").slick({
         slidesToShow: 1,
         slideToScroll: 1,
         dots: true,
         arrows: false,
         infinite: false,
         responsive: [
           {
              breakpoint: 993,
              settings: "unslick"
           }
         ]
       });
      });


      $(document).on("click",".product-form__cart-submit", function(e){
        e.preventDefault();
        $("#CartCount").removeClass("hide");
      });
  
      $(document).on("click",".body-overlay, .close-popup-cart", function(){
        $("body").removeClass("locked");
        $(".cart-popup-extended").removeClass("active");
        $(".body-overlay").removeClass("active");
      });

      $(".site-header__icon.site-header__cart").on("click", function(e){
        e.preventDefault();
        if( $(document).find("body").hasClass("locked")){
          $(document).find(".js-mobile-nav-toggle").trigger("click");


        }
        show_cart_popup();
        return false;
      });

      $(document).on("click",".cart-popup-extended .cart__remove", function(e){
        e.preventDefault();
        var parentrow = $(e.target).closest('.cart__row');
      
        let current_item_key = parentrow.attr('data-cart-item-key');

        $.ajax({
          url:'/cart/change.js',
          type: 'post',
          dataType: 'json',
          data: { quantity: 0, id: current_item_key },
          complete: function(res) {

            get_cart_data();
            parentrow.remove();
          }
        });
      });

      $(".product-slider-wrapper .product-slider").slick({
        slidesToShow: 1,
        slideToScroll: 1,
        dots: true,
        arrows: true
      });

      $(".quotes-slider-wds .quotes-slider").slick({
        slidesToShow: 2,
        slideToScroll: 2,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
        ]
      });
  
  	  $(".sps-section__slider").slick({
        slidesToShow: 1,
        slideToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false
      });

      $(document).on("click", ".js-mobile-nav-toggle", function(){
        console.log($(this).hasClass("mobile-nav--open"));
        if ($(this).hasClass("mobile-nav--open") ) {
          $(".site-header").removeClass("mobile-nav-active");
          $("body").removeClass("locked");
        } else {
        /*  $(".mobile-nav-wrapper").css("height", "auto");*/
          $(".site-header").addClass("mobile-nav-active");
          $("body").addClass("locked");
         /* $(".mobile-nav-wrapper").css("height", document.documentElement.scrollHeight);*/
        }
      });
 

    });

    function updateItemToCart(variant_id, qty, selling_plan) {
      data = {
        "id": variant_id,
        "quantity": qty,
        "selling_plan": selling_plan
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response){
          get_cart_data(upgrade);
        }
      });
    }

    function add_to_cart(data, upgrade = false){
      console.log(data)
      $.ajax({
        url:'/cart/add.js',
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(response){
          get_cart_data(upgrade);
        }
      });
    }

    function get_cart_data_upsale(form_data){
      $.ajax({
        url:'/cart.js',
        type: 'get',
        dataType: 'json',
        success: function(response){
         
          response.items.forEach(item => {
            if (item.id == '39808374833341') {
              item.quantity =  item.quantity-1;
            
              $.ajax({
                url:'/cart/change.js',
                type: 'post',
                dataType: 'json',
                data: { quantity: item.quantity, id: item.id },
                success: function(){
                  if ( item.quantity == 0) {
                    let r = $(document).find(".cart-table.top tr");
                    r.each( function() {
                      console.log($(this).attr("data-cart-item-key").substr(0, 9));
                      if ($(this).attr("data-cart-item-key").substr(0, 14) == 39808374833341) {
                        $(this).remove();
                      }
                    });
                  } 
                  add_to_cart(form_data);
                }
              });
            }
          });
        }
      });
    }

    function get_cart_data(upgrade = false){
      $.ajax({
        url:'/cart.js',
        type: 'get',
        dataType: 'json',
        success: function(response){
       
          show_cart_popup(response, upgrade);
          if (typeof  window.loader !== 'undefined' ) {
            window.loader.addClass("hide");
            window.button_text.removeClass("hide");
          }

          $("[data-cart-count]").text(response.item_count);
           return(response);
        }
      });
    }

    function get_propose(response){
      var propose = false; 
      var propose_not = true; 
      response.items.forEach(item => {
   
        if(item.id == '39808374833341' && item.quantity > 0 ) {
          propose = true; 
        } 

        if (item.id == '46651855995219') {
          propose_not = false;
          propose = false; 
        } 
      });

      if (propose && propose_not){
          return true;
      }
      return false;      
    }
   
    function show_cart_popup(response, upgrade = false){
    
      if (typeof response !== 'undefined'){
        var item_upgrade = true;
        let total_amount = theme.Currency.formatMoney(response.total_price, theme.moneyFormat);

        $(".cart-popup-extended .cart-subtotal__price").text(total_amount);
        var item_upgrade = true;
        response.items.forEach(item => {
        
          let cart_item = $(document).find(".cart-popup-extended .cart-table.top tr[data-cart-item-key='"+item.variant_id+"']");
          if(  cart_item.length == 0) {
          
            $(document).find(".cart-popup-extended .cart-table.top tr.empty").clone().appendTo(".cart-popup-extended  .cart-table.top");
            let new_item = $(document).find(".cart-popup-extended .cart-table.top tr").last();
            new_item.removeClass("empty");
            
            var str = (item.title);
            var new_str = str.replace(/ - without Stand/i,'');
            console.log (typeof new_str);
            console.log ("item title: " + new_str);
            
            new_item.attr("data-cart-item-key", item.variant_id);
            new_item.attr("data-cart-item-url", item.url);
            new_item.find(".cart__image").attr("src", item.image);
            new_item.find(".cart__product-title").text(new_str);
            new_item.find(".cart__qty-input").text(item.quantity);
            new_item.find(".cart__qty-input").val(item.quantity);
            new_item.find(".line-final-price").text(theme.Currency.formatMoney(item.line_price, theme.moneyFormat));

            if (  item.title.indexOf("with Iro stand") >= 0 ) {
              item_upgrade = false;
            }
            
          } else {

            new_item = cart_item;
            
            var str = String(item.title);
            str.replace(/ - without Stand/i,'');
            console.log (typeof str);
            console.log ("item title: " + str);

            new_item.attr("data-cart-item-key", item.variant_id);
            new_item.attr("data-cart-item-url", item.url);
            new_item.find(".cart__image").attr("src", item.image);
            new_item.find(".cart__product-title").text(str);
            new_item.find(".cart__qty-input").text(item.quantity);
            new_item.find(".cart__qty-input").val(item.quantity);
            new_item.find(".line-final-price").text(theme.Currency.formatMoney(item.line_price, theme.moneyFormat));

            if (  item.title.indexOf("with Iro stand") >= 0 ) {
              item_upgrade = false;
            }
          }
        });
        let propose = get_propose(response);
       
        if (propose) {
          $(document).find(".cart-popup-extended .upgrade").removeClass("hide");
        } else {
          $(document).find(".cart-popup-extended .upgrade").addClass("hide");
        }
      }

      if($(document).find(".cart-popup-extended .cart-table.top tr").length > 1) {
        $(document).find(".cart-popup-extended .popup-inner").removeClass("hide");
        $(document).find(".cart-popup-extended .empty-cart").addClass("hide");
      } else {
        $(document).find(".cart-popup-extended .popup-inner").addClass("hide");
        $(document).find(".cart-popup-extended .empty-cart").removeClass("hide");
      }

     
      $("body").addClass("locked");
      $(".cart-popup-extended").addClass("active");
      $(".body-overlay").addClass("active");
    }


    window.scroll_to = 0; 
    window.scroll_down = false;
    window.scroll_top = 0;

    window.onscroll = function(){
      scroll_top = $(document).scrollTop();
   

      if ( scroll_top > scroll_to ) {
        scroll_down = true;
      } else {
        scroll_down = false;
      }

      set_header_position();

      /*
      setTimeout(() => {
        animate_slider_wds();
      }, 500);
      */
      scroll_to = $(document).scrollTop();
    }

    // Animation in slider. Set images position
    function set_slider_animate(){

    $(".quotes-slider-wds .quotes-slide").each( function() {

      if( $(this).hasClass("odd") ){
        var slide_motion =  $(this).find(".image-item.index-2 .img-container");
        var slide_height = slide_motion.outerHeight();  
        var slide_height_new = slide_height-slide_height*0.25;
      } else {
        var slide_motion =  $(this).find(".image-item.index-1 .img-container");
        var slide_height = slide_motion.outerHeight();
        var slide_height_new = slide_height-slide_height*0.4;
      }
     
      let translate = slide_height-slide_height_new;
   
      slide_motion.css("height", slide_height_new+"px");
      slide_motion.find("img").css("transform", "translateY(-"+translate+"px)");
      
      slide_motion.attr("data-translatey", translate);
      slide_motion.attr("data-translatey-current", "-"+translate);
      slide_motion.addClass("animate");
    });
  }

  // Animation in slider 
  function animate_slider_wds() {

    let slider = $(".quotes-slider-wds");

    if ( slider.length  > 0) {

      var start_slider_pos = slider.offset().top  ;
      var end_slider_pos = start_slider_pos +  slider.outerHeight() + window.innerHeight;
      var h =  scroll_top + window.innerHeight/1.25;

      slider.find(".quotes-slide .animate").each( function() {
        let image_offset = $(this).offset();
      
        let t =  parseFloat($(this).attr("data-translatey"));
        let tc =  parseFloat($(this).attr("data-translatey-current"));

      
       
        if ( h > start_slider_pos && h < end_slider_pos) {
        
          let c = slider.outerHeight()/window.innerHeight;
  
          let tr = 0;
  
          if (scroll_down) {
             tr = tc+c;
          } else {
             tr = tc-c;
          }

          if (tr <= 0 &&  tr > parseFloat('-'+t)){
            $(this).find("img").css("transform", "translateY("+tr+"px)");
            $(this).attr("data-translatey-current", tr);
          }
        }
      });
    }
   }

   function init_slider_wds(){

    setTimeout(() => {
      set_slider_animate();
    }, 300);
    
     
    var slider_options = {
      canUseTouchEvents: true,
      type: 'slide',
      slideActiveClass: 'slick-active',
      slidesToShow: 2,
      slidesToScroll: 2,
      canUseTouchEvents: false,
    }

   if ($(window).width() < 768) {

      slider_options = {
        canUseTouchEvents: true,
        type: 'slide',
        slideActiveClass: 'slick-active',
        slidesToShow: 1,
        slidesToScroll: 1,
        canUseTouchEvents: true
      }
    } 

    setTimeout(() => {

      let slider = new theme.Slideshow(
        document.getElementById("data-slider-wds"),
        slider_options
        );
    }, 500);
  }
    // Change headeer background
   

    var header_change_pos;
    var header_change_pos_remove;
    function set_header_position() {
      

       if ($(document).find(".js-mobile-nav-toggle").hasClass("mobile-nav--close") ) {
        return;
         
      }

      if ( $(document).scrollTop() > 90 ) {
        clearTimeout(header_change_pos);
       
        $(".site-header, .site-header .site-header__mobile-nav").addClass("scrolling");
        if (scroll_down === false ){
          $(".scrolling").addClass("active");
          $(".scrolling").removeClass("not");
          /*header_change_pos = setTimeout(() => {
            $(".scrolling").addClass("active");
            $(".scrolling").removeClass("not");
          }, 40);
          */
        } else {
          $(".scrolling").addClass("active");
          $(".scrolling").removeClass("not");
          /*$(".scrolling").addClass("not");*/
          
          /*header_change_pos = setTimeout(() => {
            $(".scrolling").addClass("not");
          }, 40);
          */
        }
      } else {
        clearTimeout(header_change_pos_remove);
        clearTimeout(header_change_pos);
        $(".scrolling").addClass("not");                

         $(".scrolling").removeClass("active");
          $(".site-header, .site-header .site-header__mobile-nav").removeClass("scrolling");
        /*
        header_change_pos_remove = setTimeout(() => {
          $(".scrolling").removeClass("active");
          $(".site-header, .site-header .site-header__mobile-nav").removeClass("scrolling");
        }, 40);
        */
       
      }
    }

    // Animation on hero section
    if ( $(".hero_subtitles").length > 0 ) {
             
        $(".hero_subtitles").each( function(i){
          
            var items = $(this).find(".item");
            if (items.length > 0) {             
               hero_subtitles();
               var hero_animation = setInterval(hero_subtitles, 1000);
              
              items.each( function(index, el){
                  
                });
            }
        });
    }

    function hero_subtitles(){
        var items = $(".hero_subtitles .item");
      
        var current_item = $(".hero_subtitles .item.current");
        if (current_item.length > 0){
            let i = current_item.index();
         
            $(current_item).removeClass('current');
            $(current_item).addClass('hiden');
          
            let next_i = i + 1;
            if (next_i == items.length) {
                next_i = 0;
            }
            let second_i = next_i + 1;
            if (second_i == items.length) {
                second_i = 0;
            }

            let third_i = second_i + 1;
            if (third_i == items.length) {
                third_i = 0;
            }

            let second_el = items[second_i];
            let third_el = items[third_i];

            let left_padding = 30;
            if ($(window).width() < 768) {
              left_padding = 10;
            }

            let top_padding = 10;
            if ($(window).width() < 768) {
              top_padding = 6;
            }

            $(second_el).css({'transform':'translate3d('+left_padding+'px, '+top_padding+'px, 0)', 'z-index':'20'});
            $(third_el).css({'transform':'translate3d('+left_padding*2+'px, '+top_padding*2+'px, 0)', 'z-index':'10'});
            
            $(second_el).removeClass('hiden');
            $(third_el).removeClass('hiden');

            let next_el = items[next_i];

            $(next_el).find("span").css("opacity", 1 );
            $(second_el).find("span").css("opacity", 0.6 );
            $(third_el).find("span").css("opacity", 0.5 );

            $(next_el).css("opacity", 0.6 );
            $(second_el).css("opacity", 0.4 );
            $(third_el).css("opacity", 0.3 );
         
            $(next_el).removeClass('hiden');
            $(next_el).addClass('current');

        } else{
           let el = items[0];
           $(el).addClass('current');
        }
    }

    // Header links
    $(".site-nav--has-dropdown").hover( 
      function(){
        $(this).addClass("site-nav--active-dropdown");
      },
      function(){
        $(this).removeClass("site-nav--active-dropdown");
      }
    );

    $(".accordion-item p").on("click", function(){
      let parent_acccordion = $(this).closest(".accordion-item");
      parent_acccordion.siblings(".accordion-item").each( function(){
        $(this).find("p:eq(1)").slideUp(150);
        $(this).removeClass("active");
      });
      if(parent_acccordion.hasClass("active")) {
        parent_acccordion.find("p:eq(1)").slideUp(150);
        parent_acccordion.removeClass("active");
      } else {
        parent_acccordion.find("p:eq(1)").slideDown(150);
        parent_acccordion.addClass("active");
      }
    });

$(document).ajaxStop(function(){
  $('.item__title').each(function(){
    $(this).find('a').text($(this).find('a').text().replace('- without Stand', ''))
  })
})
  
  $(document).ready(function(){
    if ($('.price-item--sale').length) {
      var price = $('.price-item--sale').html()
      $('.product-form__cart-submit').append(' - <span class="btn_price">'+price+'</span>')
    }
  })
  
  $('.qty_btns a').on('click', function(e){
    e.preventDefault();
    $('.qty_btns a').removeClass('active');
    $(this).addClass('active');
    var price = $('.price-item--sale').html().replace('$', '')
    price = parseFloat(price)
    if ($(this).hasClass('one')) {
      $('.product-form__input--quantity').val('1').change()
    }
    if ($(this).hasClass('two')) {
      $('.product-form__input--quantity').val('2').change()
      price = price * 1.76
    }
    if ($(this).hasClass('three')) {
      $('.product-form__input--quantity').val('3').change()
      price = price * 2.64
    }
    price = price.toFixed(2).toString()
    console.log($('.product-form__input--quantity').val())
    $('.product-form__cart-submit .btn_price').html('$'+price)
  })

})(jQuery)


// Animation for canvas block in Hero section
var c = document.getElementById('canv');

if (typeof c !== 'object') {

var $ = c.getContext('2d');

var col = function(x, y, r, g, b) {
  $.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
  $.fillRect(x, y, 1,1);
}
var R = function(x, y, t) {
  return( Math.floor(250 + 10*Math.cos( (x*x-y*y)/300 + t )) );
}

var G = function(x, y, t) {
  return( Math.floor(210 + 10*Math.sin( (x*x*Math.cos(t/4)+y*y*Math.sin(t/3))/300 ) ) );
}

var B = function(x, y, t) {
  return( Math.floor(180 + 10*Math.sin( 5*Math.sin(t/3) + ((x-100)*(x-100)+(y-100)*(y-100))/1100) ));
}

var t = 0;

var run = function() {
  for(x=0;x<=35;x++) {
    for(y=0;y<=35;y++) {
      col(x, y, R(x,y,t), G(x,y,t), B(x,y,t));
    }
  }
  t = t + 0.015;
  window.requestAnimationFrame(run);
}

run();

}

